<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div
      v-if="!isApp || (isApp && login)"
      class="item-sku-bookmark-contents__header-area"
    >
      <PageHeadlineWithLink
        v-if="showEditOrderLink"
        title="ブックマークしたギフト"
        link-title="並べ替え"
        @click-link="onClickHeadlineLink"
      />
      <PageHeadline v-else title="ブックマークしたギフト" />
    </div>
    <div v-if="login">
      <div v-if="isBookmarksLoading">
        <div class="item-sku-bookmark-contents__white-container">
          <div class="item-sku-bookmark-contents__loading">
            <SmallLoading />
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="isEmpty">
          <div class="item-sku-bookmark-contents__white-container">
            <div class="item-sku-bookmark-contents__empty-area">
              <BookmarkWithEffectLinePrimary />
              <div class="item-sku-bookmark-contents__empty-area__title">
                ギフトをブックマークしてみましょう！
              </div>
              <p class="item-sku-bookmark-contents__empty-area__message">
                <span>ギフト詳細ページにある</span>
                <span>「ブックマークアイコン」を押すと、</span>
                <span>ブックマークしたギフトに追加され、</span>
                <span>お気に入りのギフトをすぐに贈ることができます！</span>
              </p>
            </div>
          </div>
          <div class="item-sku-bookmark-contents__bottom-link-area">
            <a :href="bottomLinkUrl">{{ bottomLinkText }}</a>
          </div>
        </div>
        <div v-else>
          <div class="item-sku-bookmark-contents__white-container">
            <div class="item-sku-bookmark-contents__item-sku-list">
              <BookmarkItemSku
                v-for="bookmark in bookmarks"
                :key="bookmark.id"
                :user-item-sku-bookmark-id="bookmark.id"
                :image-url="bookmark.imageUrl"
                :brand-name="bookmark.brandName"
                :item-name="bookmark.itemName"
                :item-sku-name="bookmark.itemSkuName"
                :item-id="bookmark.itemId"
                :item-sku-id="bookmark.itemSkuId"
                :out-of-stock="bookmark.outOfStock"
                :link-url="bookmark.linkUrl"
                :labels="bookmark.labels"
                @click-sku-basic-information-in-bookmark-item-sku="
                  clickBasicInformation
                "
                @click-bookmark-item-delete="showDeleteModal"
                @click-send-button-in-bookmark-item-sku="addToSendGiftCard"
                @click-personal-use-button-in-bookmark-item-sku="
                  createPersonalUseGiftCard
                "
              />
              <TextModal
                v-if="isDeleteModalActive"
                :title-text="'ブックマークしたギフトから削除'"
                :caption-text="'選択したギフトをブックマークしたギフトから削除してもよろしいですか？'"
                :primary-button-text="'削除する'"
                :cancel-button-text="'キャンセル'"
                @clicked-modal-cover="closeDeleteModal"
                @clicked-primary="deleteBookmark"
                @clicked-cancel="closeDeleteModal"
              />
            </div>
          </div>
          <div
            v-if="!isApp"
            class="item-sku-bookmark-contents__bottom-link-area"
          >
            <a :href="bottomLinkUrl">{{ bottomLinkText }}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="item-sku-bookmark-contents__white-container">
      <div class="item-sku-bookmark-contents__empty-area">
        <BookmarkWithEffectLinePrimary />
        <div class="item-sku-bookmark-contents__empty-area__title">
          <span>会員登録（無料）をして</span>
          <span>ギフトをブックマークしてみましょう！</span>
        </div>
        <p class="item-sku-bookmark-contents__empty-area__message">
          <span>ギフト詳細ページにある</span>
          <span>「ブックマークアイコン」を押すと、</span>
          <span>ブックマークしたギフトに追加され、</span>
          <span>お気に入りのギフトをすぐに贈ることができます！</span>
        </p>
        <div class="item-sku-bookmark-contents__empty-area__buttons">
          <ButtonPrimary
            text="新規会員登録する"
            @click-primary-button="moveToRegistrationPage"
          />
          <ButtonSecondary
            text="ログインする"
            @click-secondary-button="moveToLoginPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FeedbackSuccess from '../../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import PageHeadlineWithLink from '../../../molecules/headlines/PageHeadlineWithLink.vue'
import PageHeadline from '../../../molecules/headlines/PageHeadline.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import BookmarkItemSku from '../../../molecules/item_sku_bookmark/BookmarkItemSku.vue'
import TextModal from '../../../molecules/modals/text-modal.vue'
import BookmarkWithEffectLinePrimary from '../../../atoms/svg_icons/BookmarkWithEffectLinePrimary.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    PageHeadlineWithLink,
    PageHeadline,
    SmallLoading,
    BookmarkItemSku,
    TextModal,
    BookmarkWithEffectLinePrimary,
    ButtonPrimary,
    ButtonSecondary
  },
  props: {
    editOrderPath: {
      type: String,
      required: true
    },
    isApp: {
      type: Boolean,
      required: true
    },
    login: {
      type: Boolean,
      required: true
    },
    registrationPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      bookmarks: [],
      isBookmarksLoading: false,
      isDeleteModalActive: false,
      deleteUserItemSkuBookmarkId: null,
      deleteItemSkuId: null
    }
  },
  computed: {
    isEmpty() {
      return this.bookmarks.length === 0
    },
    showEditOrderLink() {
      return this.login && !this.isEmpty
    },
    bottomLinkText() {
      return this.isEmpty ? 'ギフト一覧から探す' : 'gifteeトップへ戻る'
    },
    bottomLinkUrl() {
      return this.isEmpty ? '/items' : '/'
    }
  },
  mounted() {
    if (this.login) {
      this.getBookmarks()
    }
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    onClickHeadlineLink() {
      location.href = this.editOrderPath
    },
    moveToRegistrationPage() {
      dataLayer.push({
        event: 'signup_click',
        button: 'bookmark_list'
      })
      location.href = this.registrationPath
    },
    moveToLoginPage() {
      dataLayer.push({
        event: 'signin_click',
        button: 'bookmark_list'
      })
      location.href = this.loginPath
    },
    async getBookmarks() {
      this.isBookmarksLoading = true
      try {
        const res = await axios.get('/api/v1/users/@me/item_sku_bookmarks')
        this.bookmarks = res.data.data.map(bookmark => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = bookmark.attributes.imageUrl
            ? bookmark.attributes.imageUrl
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: bookmark.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: bookmark.attributes.itemSkuId,
            itemSkuName: bookmark.attributes.itemSkuName,
            itemId: bookmark.attributes.itemId,
            itemName: bookmark.attributes.itemName,
            brandName: bookmark.attributes.brandName,
            outOfStock: bookmark.attributes.outOfStock,
            linkUrl: bookmark.attributes.linkUrl,
            labels: bookmark.attributes.labels || []
          }
        })
        this.isBookmarksLoading = false
      } catch (error) {
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        this.isBookmarksLoading = false
        this.showableErrorFeedback = true
      }
    },
    closeDeleteModal() {
      this.isDeleteModalActive = false
      this.deleteUserItemSkuBookmarkId = null
      this.deleteItemSkuId = null
    },
    showDeleteModal(userItemSkuBookmarkId, itemSkuId) {
      this.deleteUserItemSkuBookmarkId = userItemSkuBookmarkId
      this.deleteItemSkuId = itemSkuId
      this.isDeleteModalActive = true
    },
    async deleteBookmark() {
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_bkmk_list__unbookmark',
          item_sku_id: this.deleteItemSkuId
        })
      } else {
        logEvent('click_bkmk_list__unbookmark', {
          item_sku_id: this.deleteItemSkuId
        })
      }
      try {
        await axios.delete(
          `/api/v1/users/@me/item_sku_bookmarks/${this.deleteUserItemSkuBookmarkId}`
        )
        this.successMessage = 'ブックマークから削除しました'
        this.showableSuccessFeedback = true
        this.closeDeleteModal()
        await this.getBookmarks()
      } catch (error) {
        this.showErrorAfterApi(error)
        this.closeDeleteModal()
      }
    },
    showErrorAfterApi(error) {
      // error.response.data.message が null の場合に備えて初期値をセットする
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      this.showableErrorFeedback = true
    },
    async addToSendGiftCard(itemId, itemSkuId) {
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (this.isApp) {
        // アプリ側ではクリック後ネイティブのギフトカード作成画面に遷移するが、カードを作成するのに情報が足りないため、パラメータで必要な情報を渡す
        location.href = `/gift_card/edit?item_sku_id=${itemSkuId}&via=bookmark_list`
        return
      }
      if (!this.isApp) {
        dataLayer.push({
          event: 'add_to_cart',
          item_sku_id: itemSkuId,
          item_list_name: 'bookmark_list'
        })
      }

      try {
        await axios.post('/api/v1/pickup/gift_card_session_item_sku_contents', {
          item_sku_form: {
            item_id: itemId,
            item_sku_id: itemSkuId
          }
        })
        location.href = '/gift_card/edit'
      } catch (error) {
        this.showErrorAfterApi(error)
      }
    },
    async createPersonalUseGiftCard(itemId, itemSkuId) {
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (this.isApp) {
        // 存在しないURLだが、アプリで自家利用の購入の判別用のURL
        location.href = `/personal_purchase?item_sku_id=${itemSkuId}&via=bookmark_list`
        return
      }
      if (!this.isApp) {
        dataLayer.push({
          event: 'add_to_cart__self_use',
          item_sku_id: itemSkuId,
          item_list_name: 'bookmark_list'
        })
      }

      try {
        const res = await axios.post(
          `/api/v1/pickup/gift_card_item_sku_contents/create`,
          {
            item_sku_form: {
              item_id: itemId,
              item_sku_id: itemSkuId,
              quantity: 1,
              submit_type: 'personal_use'
            }
          }
        )
        location.href = `/draft_orders/${res.data.draft_order_id}`
      } catch (error) {
        this.showErrorAfterApi(error)
      }
    },
    clickBasicInformation(itemSkuId) {
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_bkmk_list__bkmk_item_detail',
          item_sku_id: itemSkuId
        })
      } else {
        logEvent('click_bkmk_list__bkmk_item_detail', {
          item_sku_id: itemSkuId
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item-sku-bookmark-contents {
  &__white-container {
    background-color: $white;
  }

  &__header-area {
    margin-bottom: 24px;
  }

  &__edit-link {
    flex-shrink: 0;
    padding-left: 16px;
    display: flex;
    gap: 16px;
  }

  &__loading {
    padding: 24px;
    margin: auto;
  }

  &__bottom-link-area {
    @extend %subhead;
    color: $link;
    margin: 32px 0px;
  }

  &__empty-area {
    max-width: $small-contents-width;
    padding: 40px 16px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;

    &__title {
      @extend %subhead-bold;

      span {
        display: block;
      }
    }

    &__message {
      @extend %body;
      line-height: 1.6;
      color: $gray-1;

      span {
        display: block;
      }
    }

    &__buttons {
      display: flex;
      flex-direction: column;
      gap: 16px;
      max-width: $small-contents-width;
      width: 100%;
      margin-top: 8px;
    }
  }
}
</style>
